export const RESELLER_TERMS_VERSION = '2026-07-07';

export const RESELLER_DEFAULT_COMMISSION_RATE = 10;

export const RESELLER_APPLICATION_STATUSES = [
    { id: 'submitted', label: 'Submitted', tone: 'warning' },
    { id: 'under_review', label: 'Under review', tone: 'info' },
    { id: 'approved', label: 'Approved', tone: 'success' },
    { id: 'probation', label: 'Probation', tone: 'warning' },
    { id: 'active', label: 'Active', tone: 'success' },
    { id: 'rejected', label: 'Rejected', tone: 'danger' },
    { id: 'suspended', label: 'Suspended', tone: 'danger' },
];

export const RESELLER_ACCOUNT_STATUSES = [
    { id: 'probation', label: 'Probation', tone: 'warning' },
    { id: 'active', label: 'Active', tone: 'success' },
    { id: 'paused', label: 'Paused', tone: 'muted' },
    { id: 'suspended', label: 'Suspended', tone: 'danger' },
];

export const RESELLER_COMMISSION_STATUSES = [
    { id: 'pending', label: 'Pending', tone: 'warning' },
    { id: 'approved', label: 'Approved', tone: 'info' },
    { id: 'payable', label: 'Payable', tone: 'success' },
    { id: 'paid', label: 'Paid', tone: 'success' },
    { id: 'void', label: 'Void', tone: 'danger' },
];

export const RESELLER_PAYOUT_STATUSES = [
    { id: 'scheduled', label: 'Scheduled', tone: 'warning' },
    { id: 'paid', label: 'Paid', tone: 'success' },
    { id: 'cancelled', label: 'Cancelled', tone: 'danger' },
];

export const RESELLER_AUDIENCE_TYPES = [
    { value: '', label: 'Select audience type' },
    { value: 'trading_community', label: 'Trading community' },
    { value: 'education_group', label: 'Education group' },
    { value: 'signal_group', label: 'Signal group' },
    { value: 'broker_ib', label: 'Broker IB network' },
    { value: 'content_creator', label: 'Content creator' },
    { value: 'agency', label: 'Sales or support agency' },
    { value: 'other', label: 'Other' },
];

export const RESELLER_AUDIENCE_SIZES = [
    { value: '', label: 'Select audience size' },
    { value: 'under_100', label: 'Under 100' },
    { value: '100_500', label: '100 - 500' },
    { value: '500_2000', label: '500 - 2,000' },
    { value: '2000_10000', label: '2,000 - 10,000' },
    { value: 'over_10000', label: 'Over 10,000' },
];

export const RESELLER_PAYOUT_METHODS = [
    { value: '', label: 'Select payout method' },
    { value: 'kpay', label: 'KBZPay' },
    { value: 'wavepay', label: 'WavePay' },
    { value: 'bank_transfer', label: 'Bank transfer' },
    { value: 'usdt', label: 'USDT' },
    { value: 'other', label: 'Other' },
];

export const RESELLER_PROGRAM_BENEFITS = [
    'A dedicated reseller code and tracked referral link',
    'Commission on approved paid subscriptions',
    'Product walkthroughs and promo copy for your audience',
    'Admin review for higher rates, co-marketing, or community onboarding',
];

export const RESELLER_ACCEPTANCE_CRITERIA = [
    'Trading groups, trading students, broker communities, or prop-firm study groups',
    'Educators, coaches, IBs, community managers, or trading content creators',
    'A clear channel such as Telegram, Facebook, YouTube, course groups, or offline sales',
    'Responsible promotion without misleading income or trading result claims',
];

export const RESELLER_ADMIN_REVIEW_STEPS = [
    'Apply with your audience, channel, and payout details',
    'We review audience fit and the promotion plan',
    'Approved partners receive a reseller code and starting commission rate',
    'Share Trader Journal and track referrals, commissions, and payouts',
];

export const getResellerStatusMeta = (status, options = RESELLER_APPLICATION_STATUSES) => (
    options.find((entry) => entry.id === status) || { id: status || 'unknown', label: status || 'Unknown', tone: 'muted' }
);
